import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import { HasRunbooksInGit } from "@octopusdeploy/octopus-server-client";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useEphemeralEnvironmentsEnabled() {
    return useOctopusFeatureToggle("ephemeral-environments", false);
}
export function useEphemeralEnvironmentsEnabledForProject(project: ProjectResource): boolean {
    const ephemeralEnvironmentsEnabled = useEphemeralEnvironmentsEnabled();
    return areEphemeralEnvironmentsEnabledForProject(ephemeralEnvironmentsEnabled, project);
}
export function areEphemeralEnvironmentsEnabledForProject(isEphemeralEnvironmentsEnabled: boolean, project: ProjectResource): boolean {
    return isEphemeralEnvironmentsEnabled && HasRunbooksInGit(project.PersistenceSettings);
}
